"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQueryParams = useQueryParams;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// from official react-router doc
function useQueryParams() {
  const {
    search
  } = (0, _reactRouterDom.useLocation)();
  return _react.default.useMemo(() => new URLSearchParams(search), [search]);
}